<template>
	<div class="instagram-page instagram-feed">
        <div class="d-flex justify-content-between mb-3">
            <div>
                <date-range-picker
                    ref="picker"
                    :opens="pickerOptions.opens"
                    :locale-data="pickerOptions.localeDate"
                    :timePicker="false"
                    :timePicker24Hour="false"
                    :showWeekNumbers="false"
                    :showDropdowns="true"
                    :autoApply="true"
                    v-model="dateRange"
                    :linkedCalendars="true"
                    @update="getPosts()"
                >
                    <div slot="input" slot-scope="picker" style="min-width: 350px;">
                        {{ picker.startDate | date }} - {{ picker.endDate | date }}
                    </div>
                </date-range-picker>
            </div>
            <div>
                <element-selector @input="getPosts" :elements="jwtHashtags" v-model="selectedHashtags" />
            </div>
        </div>
        <div class="row mx-0">
            <div class="card instagram-feed-card overflow-hidden" style="width: 100%">
                <div class="card-header d-none">
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive posts-table">
                        <table style="margin-bottom:0" class="table">
                            <thead>
                            <th v-on:click="setOrder('publishedDate')">
                                Date <span v-if="order === 'publishedDate'"><span v-if="sort === 'asc'"><i class="fas fa-sort-up"></i></span><span v-if="sort === 'desc'"><i class="fas fa-sort-down"></i></span></span>
                            </th>
                            <th v-on:click="setOrder('totalLikes')">
                                Total Likes <span v-if="order === 'totalLikes'"><span v-if="sort === 'asc'"><i class="fas fa-sort-up"></i></span><span v-if="sort === 'desc'"><i class="fas fa-sort-down"></i></span></span>
                            </th>
                            <th v-on:click="setOrder('totalComments')">
                                Total Comments <span v-if="order === 'totalComments'"><span v-if="sort === 'asc'"><i class="fas fa-sort-up"></i></span><span v-if="sort === 'desc'"><i class="fas fa-sort-down"></i></span></span>
                            </th>
                            <th v-on:click="setOrder('totalEngagement')">
                                Total Engagement <span v-if="order === 'totalEngagement'"><span v-if="sort === 'asc'"><i class="fas fa-sort-up"></i></span><span v-if="sort === 'desc'"><i class="fas fa-sort-down"></i></span></span>
                            </th>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>

        </div>
		<div class="row">
            <div class="col-md-12">
                <span v-if="loading">Loading..</span>
                <div class="row" v-else>
                    <div class="col-md-4 instagram-post-wrapper" v-for="post in posts">
                        <instagram-post :post="post" :key="post.id" :profile-ids="profileIDs">
                        </instagram-post>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 mt-3">
            <pagination
                :current_page="page"
                :last_page="lastPage"
                :num_items="5"
                :num_total="total">
            </pagination>
        </div>
	</div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import DateRangePicker from 'vue2-daterange-picker'
    import InstagramService from '../../services/instagram-service'
    import InstagramPost from './InstagramPost'
    import InstagramMixin from "./InstagramMixin";
    import ElementSelector from './components/ElementSelector.vue'

export default {
	components: {InstagramPost, DateRangePicker, Multiselect, ElementSelector},
    mixins: [InstagramMixin],
	props: ['teams', 'user'],
	data: function() {
		return {
			posts: [],
            page: 1,
            lastPage: null,
            total: null,
            order: 'publishedDate',
            sort: 'desc',
		}
	},
	methods: {
	    setOrder(order) {
	        if(this.order === order) {
	            if (this.sort === 'asc') {
	                this.sort = 'desc'
                } else {
	                this.sort = 'asc'
                }
            } else {
	            this.sort = 'desc'
            }

	        this.order = order

            this.getPosts()
        },
        changePage(page) {
            this.page = page
            this.getPosts()
        },
	    async getPosts(initial = false) {
            if (initial) {
                this.selectedProfiles = this.profileIDs
            }

            const params = {
                filters: {},
                from: this.dateRange.startDate,
                to: this.dateRange.endDate,
                sortBy: this.order,
                sortOrder: this.sort
            }

            if (!this.selectedHashtags.length) {
                params.hashtags = this.jwtHashtags.join(',')
            } else {
                params.hashtags = this.selectedHashtags.join(',')
            }

            this.loading = true

            const posts = await InstagramService.v2.posts.index(Object.assign({}, params, {
                limit: 12,
                page: this.page
            }))

            this.posts = posts.data

            this.lastPage = posts.lastPage
            this.total = posts.total

            this.loading = false
        }
	},
	async mounted() {
        this.$on('change-page', (index) => {
            this.changePage(index);
        });
		this.getPosts(true)
	}
}
</script>
